import { render, staticRenderFns } from "./containerPage.vue?vue&type=template&id=580dd11a&scoped=true&"
import script from "./containerPage.vue?vue&type=script&lang=js&"
export * from "./containerPage.vue?vue&type=script&lang=js&"
import style0 from "./containerPage.vue?vue&type=style&index=0&id=580dd11a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580dd11a",
  null
  
)

export default component.exports